export const SLACK_PENDING_ID_PREFIX = "temp_"

export const SLACK_DELIVERY_GRACE_MS = 60_000

export type SlackDeliveryState = "delivered" | "sending" | "undelivered"

export function isSlackMessageDelivered(slackId: string): boolean {
	return !slackId.startsWith(SLACK_PENDING_ID_PREFIX)
}

export function getSlackDeliveryState({
	type,
	slackId,
	createdAt,
	now,
}: {
	type: "INBOUND" | "OUTBOUND"
	slackId: string
	createdAt: number
	now: number
}): SlackDeliveryState {
	if (type !== "OUTBOUND" || isSlackMessageDelivered(slackId))
		return "delivered"
	return now - createdAt >= SLACK_DELIVERY_GRACE_MS ? "undelivered" : "sending"
}
